import styles from './style.module.css';

// The heading and the line under it that open every sign-in and onboarding
// screen. The intro is optional; some steps ask their question and nothing
// more.
export function PageTitle({ title, intro }) {
  let line = null;

  if (typeof intro === 'string') {
    line = <p className={ styles.intro }>{ intro }</p>;
  }

  return (
    <div className={ styles.title }>
      <h1 className={ styles.heading }>{ title }</h1>

      { line }
    </div>
  );
}
